module.exports = __webpack_public_path__ + "static/media/3.2221af18.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/原味司康/3.JPG
// module id = 928
// module chunks = 0